import { Configs } from './Configs';
import { defaults } from './defaults';

const configs: Configs = {
  authEnabled: defaults.auth_enabled,
  testAds: defaults.test_ads,
};

export default configs;
